import { call, put } from 'redux-saga/effects';
import {
  uploadOrganisationAttachmentFailure,
  uploadOrganisationAttachmentSuccess,
} from '../actions';
import { uploadOrganisationAttachment } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';

import { checkResponse } from 'store/utils';
import { UploadOrganisationAttachmentParams } from '../models';
import { UploadOrganisationAttachmentRequestAction } from '../types';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* uploadOrganisationAttachmentSaga(
  action: UploadOrganisationAttachmentRequestAction
) {
  try {
    let err: ApiError | null;

    const params: UploadOrganisationAttachmentParams = action.payload.params;

    const uploadResponse: ApiResponse = yield call(
      uploadOrganisationAttachment,
      params
    );

    err = checkResponse(uploadResponse?.responseMessage);
    if (err) throw err;
    yield put(
      uploadOrganisationAttachmentSuccess(
        params.organisationId,
        uploadResponse.data.attachment
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(uploadOrganisationAttachmentFailure());
  }
}
